<template>
  <section id="angebot" class="s2">
    <h1>Angebot</h1>
    <article class="offers-wrapper">
      <div class="offer-tease" v-scroll-reveal>
        <img class="offer-ico" src="@/assets/svg/pen.svg" alt="" />
        <h3>Creative</h3>
        <p>
          Kreative Projekte wie <br />
          Documentaries, Musikvideos,<br />
          Designs usw.
        </p>
      </div>
      <div class="offer-tease" v-scroll-reveal>
        <img class="offer-ico" src="@/assets/svg/building.svg" alt="" />
        <h3>Corporate</h3>
        <p>
          Werbe- & Imagefilme, <br />
          Corporate-Fotos,<br />
          Eventvideo usw.
        </p>
      </div>
    </article>
    <div class="btn-wraper">
      <a href="mailto:info@ocular.ch" v-smooth-scroll
        ><button class="btn-big btn-blue">Kontakt</button></a
      >
      <router-link to="#projects" v-smooth-scroll
        ><button class="btn-big btn-border">
          unsere Arbeiten
        </button></router-link
      >
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
#angebot {
  .offers-wrapper {
    display: flex;
    justify-content: center;
    margin: 0;
    .offer-tease {
      text-decoration: none;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 40rem;
      height: 40rem;
      padding: 2rem 2rem 2rem 2rem;
      margin: 0 3rem;
      background-color: #f5f4f3;
      border-radius: 10px;
      transition: 0.3s;
      &:hover {
        transform: scale(1.02) !important;
      }
      .offer-ico {
        display: flex;
        align-items: center;
        width: 15rem;
        margin: 0 0 1rem 0;
      }
      h3 {
        margin: 0 0 1rem 0;
      }
      p {
        margin: 0 0 4rem 0;
      }
      a {
        margin: 0 0 4rem 0;
      }
    }
  }
  .btn-wraper {
    margin-top: 9rem;
    button {
      margin: 0 1.2rem;
    }
  }
}
@media only screen and (max-width: 1024px) {
  #angebot {
    .offers-wrapper {
      flex-direction: column;
      .offer-tease {
        width: 100%;
        height: initial;
        padding: 7vw 2vw 7vw 2vw;
        margin: 0 0 5vh 0;
        a {
          margin: 0rem 0 2rem 0;
        }
      }
    }
    .btn-wraper {
      margin-top: 3rem;
      button {
        margin: 1.2rem;
      }
    }
  }
}
</style>
